export const filter = {
    id: null,
    partner_clinic_id: null,
    courier_id: null,
    search: "",
    created_at: "",
    updated_at: "",
};
